import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import Template from "./Template";

export default class Templates extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'template',
            data: null,
            loading: true,
            configName: 'templates_grid',
            moduleName: 'الگوها',
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "typeString", caption: "نوع", show: true },
                { field: "createDatePersian", caption: "تاریخ ثبت", show: true },
                { field: "editDatePersian", caption: "تاریخ بروزرسانی", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, flex: 2, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'typeString' && f.show) t.push({ field: f.field, flex:2, headerName: f.caption });
            if (f.field == 'createDatePersian' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDatePersian' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    onEdit(id) {
        this.showComponents({ component: <Template Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Template Caller={this} /> });
    }
    renderForm() {
        return <div className="nk-content-body">
            <div className="nk-block">
                <div className="card card-bordered card-stretch">
                    <div className="card-inner-group">
                        <div className="card-inner p-0">
                            {this.getToolBar()}
                            {this.renderAgGrid({
                                columnDefs: this.getColumns()
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}